// components/PropertyFeatures.js
import React from 'react';

const PropertyFeatures = ({ formData, setFormData }) => {
    const features = [
        { label: 'Kitchen', field: 'numberOfKitchens' },
        { label: 'Bedrooms', field: 'numberOfBedrooms' },
        { label: 'Bathrooms', field: 'numberOfBathrooms' },
        { label: 'Balconies', field: 'numberOfBalconies' },
        { label: 'Car Parking', field: 'carParking' }
    ];

    const handleIncrement = (field) => {
        setFormData((prev) => ({
            ...prev,
            [field]: (prev[field] || 0) + 1,
        }));
    };

    const handleDecrement = (field) => {
        setFormData((prev) => ({
            ...prev,
            [field]: Math.max(0, (prev[field] || 0) - 1),
        }));
    };

    return (
        <>
            <div className="row">
                {features.map(({ label, field }) => (
                    <div className="col-md-6 col-lg-4 mb-4" key={field}>
                        <div className="border rounded p-3 d-flex justify-content-between align-items-center shadow-sm">
                            <strong>{label}</strong>
                            <div className="d-flex align-items-center gap-2">
                                <button
                                    type="button"
                                    className="btn btn-outline-danger rounded-circle px-3"
                                    onClick={() => handleDecrement(field)}
                                >
                                    &minus;
                                </button>
                                <span className="fw-bold px-2">{formData[field] || 0}</span>
                                <button
                                    type="button"
                                    className="btn btn-outline-success rounded-circle px-3"
                                    onClick={() => handleIncrement(field)}
                                >
                                    +
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default PropertyFeatures;
